export default __webpack_public_path__ + "static/media/gallery-image-1.ece54d10.jpg";